import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// import { useRouteMatch } from "react-router-dom";

// import Tab from "./Tab";
import Footer from "./footer/Footer";
import TopBanner from "./topBanner/TopBanner";
import VideoList from "./video-list/VideoList";
// import VideoDetailDialog from "../dialog/videoDetail/Dialog";
import TimeLineDialog from "../dialog/videoDetail/TimeLineDialog";
import QuestionDialog from "../dialog/question/Dialog";

// 회원 비회원 구분을 위해 추가 (회원이 문의하기 버튼 클릭시 젠데스크로 이동)
import api from "../../api/ajax";
import { useQuery } from "@apollo/react-hooks";
import { GET_USER_INFO } from "../../api/gql";
import { ENUM_API_TYPE } from "../../enum/API";
import { IInitialInfo } from "../../models/UserInfo.interface";

function MainPresenter(props: any): JSX.Element {
  const { t } = useTranslation();
  const [isQuestionDialogOpen, setQuestionDialog] = useState<boolean>(false);
  const [isVideoDetailDialogOpen, setVideoDetailDialogOpen] = useState<boolean>(false);

  // 회원 비회원 구분을 위해 추가 (회원이 문의하기 버튼 클릭시 젠데스크로 이동)
  const { data } = useQuery<IInitialInfo>(GET_USER_INFO);
  const clickQuestionButton = () => {
    if(data) {
      api(ENUM_API_TYPE.POST).moveZendeskUrl();
    } else {
      window.open('https://wehagohelp.zendesk.com');
    }
  };

  // const match: any = useRouteMatch();
  // const year: String = match?.params?.year || "2023";
  // const videoCategory = {
  //   "2020": 5,
  //   "2021": 2021,
  //   "2022": 2022,
  //   "2023": 2023,
  // };

  return (
    <div id="wrap" className="evg dz_font">
      <div className="dtp">
        <div className="container">
          <TopBanner
            setQuestionDialog={setQuestionDialog}
            clickQuestionButton={clickQuestionButton}
          />

          <div className="section video_wrap">
            <div className="align_wh">
              {/* 2024년부터는 이전 비디오리스트 안 보여주도록 변경되서 탭 제거함 */}
              {/* <Tab /> */}

              <VideoList
                title={t("subTitle")}
                // category={videoCategory[year]}
                setVideoDetailDialogOpen={setVideoDetailDialogOpen}
                isVideoDetailDialogOpen={isVideoDetailDialogOpen}
              />
            </div>
          </div>

          <Footer />

          {/* {year === "2020" && isVideoDetailDialogOpen && (
            <VideoDetailDialog
              setVideoDetailDialogOpen={setVideoDetailDialogOpen}
            />
          )} */}

          {isVideoDetailDialogOpen && (
            <TimeLineDialog
              setVideoDetailDialogOpen={setVideoDetailDialogOpen}
            />
          )}

          {isQuestionDialogOpen && (
            <QuestionDialog setQuestionDialog={setQuestionDialog} />
          )}
        </div>
      </div>
    </div>
  );
}

export default MainPresenter;
